/**
 * How a price is written down, in one place.
 *
 * A narrow no-break space groups the thousands — the Polish convention, and
 * the one separator that cannot be misread as a decimal point the way a comma
 * or a full stop can. It is no-break so "1 000" never wraps across two lines
 * and becomes two numbers.
 *
 * The currency and the words "netto + VAT" live in the `plans` namespace
 * (`price.net`, `price.unit`), because sales here are B2B and both languages
 * have to say it. The number is net (team decision, 24 September 2026, which
 * reverses the gross pricing of 12 September): Stripe adds 23% VAT on top at
 * checkout, so nothing here may add a rate to what the catalogue quotes.
 * Nothing in the frontend ever hardcodes an amount: every number on the screen
 * comes from `GET /api/billing/plans/`.
 */

const NARROW_NO_BREAK_SPACE = '\u202F'

/** `1000` → `1 000`. Whole zloty only — we do not sell fractions of one. */
export function formatAmount(amount: number): string {
  return Math.round(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, NARROW_NO_BREAK_SPACE)
}
